var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-badge',{staticClass:"mx-2",attrs:{"color":_vm.action.typ_color,"dot":"","inline":"","left":""}},[_c('v-btn',{staticClass:"pa-0 ma-0",attrs:{"text":""}},[_vm._v(_vm._s(_vm.action.typ_label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }